/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

export const getHumanReadableMeetingId = (
  meetingIdWithoutDashes: string
): string => {
  if (/^\d{9}$/.test(meetingIdWithoutDashes)) {
    return meetingIdWithoutDashes.replace(/(\d{3})/g, '$1-').slice(0, 11);
  }
  return meetingIdWithoutDashes;
};
